import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Configuration } from '../app.constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ImgZipperService {
  private baseUrl: string;

  constructor(private config: Configuration, private http: HttpClient) {
    // this.baseUrl = this.config.endpoint;
    this.baseUrl =
      'https://pixel-match-api-229508468478.us-central1.run.app/api/v1';
  }

  matchZip(campaignType, campaignName, file) {
    if (!campaignType) {
      return throwError('[img-zipper.service]: not campaignType provided');
    }
    if (!campaignName) {
      return throwError('[img-zipper.service]: not campaignName provided');
    }
    if (!file) {
      return throwError('[img-zipper.service]: not file provided');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('campaignType', campaignType);
    formData.append('campaignName', campaignName);
    return this.http.post(`${this.baseUrl}/matchZip`, formData, {
      responseType: 'blob',
    });
  }

  getMatchInfo(campaignType, campaignName, file) {
    if (!campaignType) {
      return throwError('[img-zipper.service]: not campaignType provided');
    }
    if (!campaignName) {
      return throwError('[img-zipper.service]: not campaignName provided');
    }
    if (!file) {
      return throwError('[img-zipper.service]: not file provided');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('campaignType', campaignType);
    formData.append('campaignName', campaignName);
    return this.http.post(`${this.baseUrl}/match`, formData);
  }
}
